import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUnion = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" {...props}>
    <path fill="#616061" fillRule="evenodd" d="M0 0v14h14V0zm12 9V2H2v7h3a2 2 0 0 0 4 0z" clipRule="evenodd" />
  </svg>
);
export default SvgUnion;
